import loginSettingApi from '../../api/loginSetting';

const state = {
  config: {
    auto_logout_enabled: false,
    auto_logout_time: 15 * 60 * 1000, // Default: 15 minutes
    warning_time: 14 * 60 * 1000, // Default: 14 minutes
    allow_multiple_logins: true,
  },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

const mutations = {
  SET_CONFIG(_state, config) {
    _state.config = config;
  },
};

const actions = {
  async fetch({ commit }) {
    try {
      const response = await loginSettingApi.get();
      commit('SET_CONFIG', response.data);
    } catch (error) {
      throw new Error(error?.response?.data?.message);
    }
  },

  async update({ commit }, config) {
    try {
      const response = await loginSettingApi.update({ login_setting: config });
      commit('SET_CONFIG', response.data);
    } catch (error) {
      throw new Error(error?.response?.data?.message);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
